import React, { useState, useEffect } from "react";
import axios from "../../../../../api/axios";
import {
  FaBattleNet,
  FaInfo,
  FaBriefcase,
  FaRegMoneyBillAlt,
  FaKey,
  FaMapMarkerAlt,
  FaLongArrowAltRight,
  FaLongArrowAltUp,
  FaStreetView,
  FaImages,
  FaSortAmountDown,
  FaBed,
  FaBath,
  FaWarehouse,
} from "react-icons/fa";
import { useLocation, useParams } from "react-router-dom";

import { GoCloudUpload } from "react-icons/go";

import "./AddNew.css";
import DashMenu from "../../../../atoms/DashMenu/DashMenu";
import SyncLoader from "react-spinners/SyncLoader";
import SubHeader from "../../../../atoms/SubHeader/SubHeader";

const AddNew = ({ toggleMenu, showMenu }) => {
  const [propertyName, setPropertyName] = useState("");
  const [propertyCategory, setPropertyCategory] = useState("");
  const [propertyPrice, setPropertyPrice] = useState("");
  const [propertyImage, setPropertyImage] = useState(null);
  const [state, setState] = useState("");
  const [lga, setLga] = useState("");
  const [street, setStreet] = useState("");
  const [ammenities, setAmmenities] = useState("");
  const [bedroom, setBedroom] = useState("");
  const [bathroom, setBathroom] = useState("");
  const [description, setDescription] = useState("");
  const [garage, setGarage] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [preview, setPreview] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const { pathname } = location;
  const isEditAction = pathname.endsWith("/edit");

  let { slug } = useParams();
  const MANAGE_LISTING = "/api/add/property";
  const EDIT_URL = "/api/update/property/" + slug;
  const USERS_LIST = `/api/show/visitor/property/${slug}`;

  const API_URL = isEditAction ? EDIT_URL : MANAGE_LISTING;

  useEffect(() => {
    if (propertyImage && typeof propertyImage !== "string") {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(propertyImage);
    } else {
      setPreview(null);
    }
  }, [propertyImage]);

  useEffect(() => {
    if (isEditAction) {
      axios
        .get(USERS_LIST)
        .then((res) => {
          setAmmenities(res.data.data.ammentities);
          setPropertyName(res.data.data.property_name);
          setPropertyCategory(res.data.data.property_category);
          setPropertyPrice(res.data.data.property_price.replaceAll(",", ""));
          setPreview(res.data.data.property_image);
          setState(res.data.data.state);
          setLga(res.data.data.lga);
          setBedroom(res.data.data.no_bedrooms);
          setBathroom(res.data.data.no_bathrooms);
          setGarage(res.data.data.garage_size);
          setDescription(res.data.data.description);
          setStreet(res.data.data.street);
        })
        .catch((err) => console.log(err));
    }
  }, [USERS_LIST, isEditAction]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };

    const formData = new FormData();
    formData.append("ammentities", ammenities);
    formData.append("property_image", propertyImage);
    formData.append("property_name", propertyName);
    formData.append("property_category", propertyCategory);
    formData.append("property_price", propertyPrice);
    formData.append("state", state);
    formData.append("lga", lga);
    formData.append("no_bedrooms", bedroom);
    formData.append("no_bathrooms", bathroom);
    formData.append("garage_size", garage);
    formData.append("description", description);
    formData.append("street", street);


    try {
      const response = await axios.post(API_URL, formData, config);
      console.log(response?.data);
      console.log(response?.accessToken);
      console.log(JSON.stringify(response));

      setAmmenities("");
      setPropertyName("");
      setPropertyCategory("");
      setPropertyPrice("");
      setPropertyImage(null);
      setState("");
      setLga("");
      setBedroom("");
      setBathroom("");
      setGarage("");
      setDescription("");
      setStreet("");
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 409) {
        setErrMsg("AddNew Failed");
      } else {
        setErrMsg("AddNew Failed");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="dashboard-home-wrapper">
      <div className="dashmenu-style">
        <DashMenu toggleMenu={toggleMenu} showMenu={showMenu} />
      </div>
      <SubHeader title={"ADD NEW"} />
      <p className={errMsg ? "errmsg" : "offscreen"} arial-live="assertive">
        {errMsg}
      </p>
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="add-message-content-wrapper">
          <div className="add-box add-box1">
            <div className="add-header">
              <div className="add-links">
                <a href="#info">Info</a>
                <a href="#location">Location</a>
                <a href="#Media">Media</a>
                <a href="#Details">Details</a>
                <a href="#Rooms">Rooms</a>
                <a href="#plan">Plan</a>
                <a href="#widget">Widgets</a>
              </div>
              <div className="net-wrap">
                <FaBattleNet className="net" />
              </div>
            </div>
          </div>
          <div className="add-box add-box2">
            <div className="box2-header">
              <FaInfo className="info-icon" />
              <h4>Basic Informations</h4>
            </div>
            <div className="add1-info">
              <div className="add-info-wrap">
                <label htmlFor="myfile">Property Name</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaBriefcase className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="propertyname"
                    onChange={(e) => setPropertyName(e.target.value)}
                    value={propertyName}
                    required
                    placeholder="Property Name"
                  />
                </div>
              </div>
              <div className="add-info-wrap">
                <label for="myfile">Type</label>
                <div className="input-style">
                  <select
                    data-placeholder="All Categories"
                    className="select-style"
                    onChange={(e) => setPropertyCategory(e.target.value)}
                    value={propertyCategory}
                  >
                    <option value="all">Type</option>
                    <option value="sale">For Sale</option>
                    <option value="rent">For Rent</option>
                  </select>
                </div>
              </div>
              <div className="add-info-wrap">
                <label for="myfile">Listing Price (NGN)</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaRegMoneyBillAlt className="userprofile" />
                  </div>
                  <input
                    type="number"
                    id="propertyPrice"
                    onChange={(e) => setPropertyPrice(e.target.value)}
                    value={propertyPrice}
                    required
                    placeholder="Property Price"
                  />
                </div>
              </div>
            </div>
            <div className="add2-info">
              <div className="add-info-wrap3">
                <label for="myfile">Description</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaKey className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="description"
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                    required
                    placeholder="Description of Property"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="add-box add-box3">
            <div className="box2-header">
              <FaStreetView className="info-icon" />
              <h4>Location / Contacts</h4>
            </div>
            <div className="add1-info">
              <div className="add-info-wrap">
                <label for="myfile">Address or Street</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaMapMarkerAlt className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="street"
                    onChange={(e) => setStreet(e.target.value)}
                    value={street}
                    required
                    placeholder="Address or Street of Property"
                  />
                </div>
              </div>
              <div className="add-info-wrap">
                <label for="myfile">L.G.A</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaLongArrowAltRight className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="street"
                    onChange={(e) => setLga(e.target.value)}
                    value={lga}
                    required
                    placeholder="Local Government Area"
                  />
                </div>
              </div>
              <div className="add-info-wrap">
                <label for="myfile">State</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaLongArrowAltUp className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="state"
                    onChange={(e) => setState(e.target.value)}
                    value={state}
                    required
                    placeholder="State of Property"
                  />
                </div>
              </div>
            </div>
            <div className="add3-info">
              <div className="add-info-wrap">
                <label for="myfile">Number of Bedrooms</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaBed className="userprofile" />
                  </div>
                  <input
                    type="number"
                    id="bedroom"
                    onChange={(e) => setBedroom(e.target.value)}
                    value={bedroom}
                    required
                    placeholder="Number of Bedrooms"
                  />
                </div>
              </div>
              <div className="add-info-wrap3">
                <label for="myfile">Number of Bathroom</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaBath className="userprofile" />
                  </div>
                  <input
                    type="number"
                    id="bathroom"
                    onChange={(e) => setBathroom(e.target.value)}
                    value={bathroom}
                    required
                    placeholder="Number of Bathroom"
                  />
                </div>
              </div>
            </div>
            <div className="add3-info">
              <div className="add-info-wrap">
                <label for="myfile">Garage Size</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaWarehouse className="userprofile" />
                  </div>
                  <input
                    type="number"
                    id="garage"
                    onChange={(e) => setGarage(e.target.value)}
                    value={garage}
                    required
                    placeholder="Number of Cars"
                  />
                </div>
              </div>
              <div className="add-info-wrap3">
                <label for="myfile">Ammenities</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaSortAmountDown className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="ammenities"
                    onChange={(e) => setAmmenities(e.target.value)}
                    value={ammenities}
                    required
                    placeholder="Ammenities"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="add-box add-box4">
            <div className="box2-header">
              <FaImages className="info-icon" />
              <h4>Property Image</h4>
            </div>
            <div className="ad-info">
              <div action="" className="fuzone">
                <div className="fu-text">
                  <input
                    type="file"
                    id="file"
                    name="filename"
                    accept="image/png, image/jpeg, image/jpg"
                    className="upload-btn"
                    // onChange={(e) => setPropertyImage(e.target.files[0])}
                    onChange={(e) => setPropertyImage(e.target.files[0])}
                    // value={propertyImage}
                  />
                  {preview ? (
                    <img
                      className="upload-label2"
                      src={preview}
                      alt="preview"
                      onClick={() => {
                        setPropertyImage(null);
                      }}
                    />
                  ) : (
                    <label className="upload-label" for="file">
                      <div>
                        <GoCloudUpload className="upload" />
                        <p>Click here or drop file to upload</p>
                      </div>
                    </label>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className="loading">
            <SyncLoader color={"#3270fc"} loading={isLoading} size={10} />
          </div>
        ) : (
          <div className="login-btn">
            <button type="submit" className="login-button">
              Submit
            </button>
          </div>
        )}
      </form>
    </div>
  );
};

export default AddNew;
